import { FeedController, ModelUpdateEvent, DataReceiveEvent } from "@gaming/srvg-classes-core";

// uses srvg.featuresInstances

export class OddsfeedController extends FeedController {

    constructor( options) {
        options = options || {};
        super( options );

        this.name = 'oddsfeedController';
    }

    poll( parameters, callback ) {
        if( srvg.featuresInstances.getDisableComboButton() ) {
            return;
        }
        return super.poll( parameters, callback );
    }

    handleModelUpdateEvent( event: ModelUpdateEvent ) {
        if( event.propertyName == 'selectedMatchday' ) {
            var matchday = event.propertyValue;
            var parameters = {
                season_id: matchday.getSeason().id,
                matchday_nr: matchday.nr
            };
            var result = this.cache.get( parameters );
            if( ! result ) {
                this.poll( parameters, null );
            }
            else {
                this.triggerEvent( new DataReceiveEvent( result, parameters ) );
            }
        }
    }
}